import React, { Component } from 'react'
import { PropTypes as T } from 'prop-types'
import { connect } from 'react-redux'

import ToggleWithLabel from './ToggleWithLabel'
import { followUser, unfollowUser } from '../store/actions/userFollowActions'

class UserFollowButton extends Component {
  static propTypes = {
    dispatch: T.func.isRequired,
    followersCount: T.number,
    following: T.bool,
    href: T.string.isRequired,
    username: T.string.isRequired,
  }

  render() {
    return (
      <div className="btn btn-small border rounded">
        <ToggleWithLabel
          iconOff="plus"
          iconOn="check"
          labelOff="Follow"
          labelOn="Following"
          on={this.props.following}
          onClick={this.handleClick} />
      </div>
    )
  }

  handleClick = () => {
    const action = this.props.following ? unfollowUser : followUser
    this.props.dispatch(
      action(this.props.href, this.props.username, this.props.followersCount)
    )
  }
}

function mapStateToProps(state, ownProps) {
  const userFollows = state.userFollows || { items: [], counts: {} }
  const items = userFollows.items || []
  const counts = userFollows.counts || {}
  const following = items.indexOf(ownProps.username) > -1
  const followersCount = Object.prototype.hasOwnProperty.call(counts, ownProps.username)
    ? counts[ownProps.username]
    : ownProps.followersCount

  return {
    following,
    followersCount,
  }
}

export default connect(mapStateToProps)(UserFollowButton)
